
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programs",
      function () {
        return require("private-next-pages/programs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programs"])
      });
    }
  